import { css } from "@emotion/react";
import colors from "@moodys/mdc-frontend.theming.colors";

export const footerStyles = {
  footer: css({
    width: "100%",
    background: colors.globalBlue800,
    color: colors.globalWhite,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: "64px 24px 0 24px",
    boxSizing: "border-box",
  }),
  logo: css({
    height: "42px",
    width: "198px !important",
    fill: "currentColor",
  }),
  list: css({
    width: "100%",
    paddingBottom: 0,
    marginTop: 32,
  }),
  container: css({
    display: "block",
    width: "100%",
    marginBottom: 32,
    maxWidth: 1536,
  }),
  desktopContainerLinks: css({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    gap: "48px 24px",
    height: 640,
    marginTop: 32,

    "> div:first-of-type": {
      marginBottom: 24,
    },
  }),
  endingDivider: css({
    width: "100%",
    margin: "32px 0",
  }),
  caption: css({
    color: "rgb(191, 191, 191)",
    marginBottom: 0,
  }),
  oneTrustButton: css({
    display: "none",
  }),
};
